/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_UndoInputs */

const vi_shop_undo = /** @type {(inputs: Shop_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tác`)
};

/**

* @param {Shop_UndoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_undo = /** @type {((inputs?: Shop_UndoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_UndoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_undo(inputs)
});